import { render, staticRenderFns } from "./MortgageApplicationsChoiceWrapper.vue?vue&type=template&id=92dbe49c&scoped=true&"
import script from "./MortgageApplicationsChoiceWrapper.vue?vue&type=script&lang=js&"
export * from "./MortgageApplicationsChoiceWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MortgageApplicationsChoiceWrapper.vue?vue&type=style&index=0&id=92dbe49c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dbe49c",
  null
  
)

export default component.exports